import { render, staticRenderFns } from "./dialog-tax-invoice-citizen.vue?vue&type=template&id=c8c6832e&"
import script from "./dialog-tax-invoice-citizen.vue?vue&type=script&lang=js&"
export * from "./dialog-tax-invoice-citizen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports